import { BaseController } from '@/api/BaseController';
import { RequestOption } from '@/common/http/types';
import { ANY_OBJECT } from '@/types/generic';
import { TableData } from '@/common/types/table';
import { useUrlBuilder } from '@/common/hooks/useUrl';
import PublicServiceReception from '@/types/table/publicServiceReception';
import { PublicReceptionObjectData } from '@/api/generated/publicReceptionObjectController';
import { PublicReceptionScheduleData } from '@/api/generated/publicReceptionScheduleController';
import { PublicServiceReceptionExpensesData } from '@/api/generated/publicServiceReceptionExpensesController';
import { API_CONTEXT } from '../config';

const { buildGetUrl } = useUrlBuilder();

export interface PublicServiceReceptionData extends PublicServiceReception {
  publicReceptionObjectList?: PublicReceptionObjectData[];
  publicReceptionScheduleList?: PublicReceptionScheduleData[];
  publicServiceReceptionExpensesList?: PublicServiceReceptionExpensesData[];
  __cascade_add_temp_id__?: string | number | undefined;
}

export default class PublicServiceReceptionController extends BaseController {
  static list(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post<TableData<PublicServiceReceptionData>>(API_CONTEXT + '/app/publicServiceReception/list', params, httpOptions);
  }
  static view(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.get<PublicServiceReceptionData>(API_CONTEXT + '/app/publicServiceReception/view', params, httpOptions);
  }
  static export(params: ANY_OBJECT, fileName: string) {
    return super.download(API_CONTEXT + '/app/publicServiceReception/export', params, fileName);
  }
  static import(params: ANY_OBJECT) {
    return super.upload(API_CONTEXT + '/app/publicServiceReception/import', params);
  }
  static printUrl(params: ANY_OBJECT) {
    return buildGetUrl(API_CONTEXT + '/app/publicServiceReception/print', params);
  }
  static add(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/publicServiceReception/add', params, httpOptions);
  }
  static update(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/publicServiceReception/update', params, httpOptions);
  }
  static delete(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/publicServiceReception/delete', params, httpOptions);
  }
  static deleteBatch(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/publicServiceReception/deleteBatch', params, httpOptions);
  }
  static startOnlyPublicServiceReception(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/publicServiceReception/startOnly/PublicServiceReception', params, httpOptions);
  }
  static startWithBusinessKeyPublicServiceReception(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/publicServiceReception/startWithBusinessKey/PublicServiceReception', params, httpOptions);
  }
  static startAndTakeUserTaskPublicServiceReception(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/publicServiceReception/startAndTakeUserTask/PublicServiceReception', params, httpOptions);
  }
  static startAndSaveDraftPublicServiceReception(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/publicServiceReception/startAndSaveDraft/PublicServiceReception', params, httpOptions);
  }
  static submitUserTaskPublicServiceReception(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/publicServiceReception/submitUserTask/PublicServiceReception', params, httpOptions);
  }
  static viewTaskBusinessDataPublicServiceReception(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.get(API_CONTEXT + '/app/publicServiceReception/viewTaskBusinessData/PublicServiceReception', params, httpOptions);
  }
  static viewHistoricTaskBusinessDataPublicServiceReception(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.get(API_CONTEXT + '/app/publicServiceReception/viewHistoricTaskBusinessData/PublicServiceReception', params, httpOptions);
  }
  static listWorkOrderPublicServiceReception(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/publicServiceReception/listWorkOrder/PublicServiceReception', params, httpOptions);
  }

    static getUserInformation(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post<TableData<PublicServiceReceptionData>>(API_CONTEXT + '/app/dept/getUserInformation', params, httpOptions);
  }
  static deleteMessage(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/dept/deleteMessage', params, httpOptions);
  }
}
